import { Injectable, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    // Mapeo de códigos de error del backend a claves i18n
    private readonly ERROR_CODE_MAP: Record<string, string> = {
        '1066': 'error_insufficient_stock',
        '1067': 'error_product_not_found',
        '1068': 'error_cart_expired',
        // Añadir más códigos según se necesiten
    };

    constructor(
        private toastr: ToastrService,
        private translate: TranslateService,
        private ngZone: NgZone
    ) { }

    showError(message: string, title?: string): void {
        // Run inside Angular zone to ensure immediate change detection
        this.ngZone.run(() => {
            this.toastr.error(message, title || this.translate.instant('error'));
        });
    }

    showSuccess(message: string, title?: string): void {
        this.ngZone.run(() => {
            this.toastr.success(message, title);
        });
    }

    showWarning(message: string, title?: string): void {
        this.ngZone.run(() => {
            this.toastr.warning(message, title);
        });
    }

    showInfo(message: string, title?: string): void {
        this.ngZone.run(() => {
            this.toastr.info(message, title);
        });
    }

    /**
     * Maneja errores HTTP del backend usando el código de error
     * para mostrar un mensaje i18n apropiado
     */
    handleBackendError(error: any): void {
        console.log('[NotificationService] handleBackendError called');

        const errorCode = error?.error?.code;
        const i18nKey = this.ERROR_CODE_MAP[errorCode] || 'error_generic';
        const message = this.translate.instant(i18nKey);

        console.log('[NotificationService] Showing toast:', message);
        this.showError(message);
    }
}
